module.exports = __webpack_public_path__ + "static/img/item1.ea3b6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item1.png
// module id = iwft
// module chunks = 1